import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationAppEntityApplicationRead } from '../openapi';

@Pipe({
  name: 'hasLandRegisterLabel',
  standalone: true
})
export class HasLandRegisterLabelPipe implements PipeTransform {

  transform(application?: ApplicationAppEntityApplicationRead | null): string {
    switch (true) {
      case application?.service?.url === '/podatek-lesny-il-1': {
        return 'Czy las posiada księgę wieczystą?';
      }
      case application?.service?.url === '/podatek-lesny-dl-1': {
        return 'Czy las posiada księgę wieczystą?';
      }
      case application?.service?.url === '/podatek-rolny-ir-1': {
        return 'Czy grunt posiada księgę wieczystą?';
      }
      case application?.service?.url === '/podatek-rolny-dr-1': {
        return 'Czy grunt posiada księgę wieczystą?';
      }
      case application?.service?.url === '/podatek-od-nieruchomosci-in-1': {
        return 'Czy nieruchomość posiada księgę wieczystą?';
      }
      case application?.service?.url === '/podatek-od-nieruchomosci-dn-1': {
        return 'Czy nieruchomość posiada księgę wieczystą?';
      }
      default: {
        return '';
      }
    }
  }

}
